import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-grid-system';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';

import { useApp } from '../../_libs/hooks/useApp';
import { useBrand } from '../../_libs/hooks/useBrand';

import Navigation from '../../molecules/Navigation';
import ErrorBoundary from '../../organisms/ErrorBoundary';
import axios from 'axios';

const IntroRadius = (): JSX.Element => {
  const {
    radius,
    reportData,
    zipCode,
    setRadius,
    userId,
  } = useApp();
  const {
    primaryBrand,
    coBrand,
  } = useBrand();
  const { 
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const [currName, setCurrName] = useState<string>(primaryBrand.name);
  const [currZip, setCurrZip] = useState<string>(zipCode);

  const navigate = useNavigate();

  useEffect(() => { 
    if (!primaryBrand.name) {
      navigate('/name/');
    } else {
      setCurrName(primaryBrand.name);
    }
  }, [primaryBrand.name]);
  useEffect(() => { 
    if (!zipCode) {
      navigate('/zip/');
    } else {
      setCurrZip(zipCode);
    }
  }, [zipCode]);
  useEffect(() => { setValue('radius', `${radius}`); }, [radius]);

  function onSubmit (data: Record<any, any>) {
    axios
      .post('/update_report/', {
        reportId: reportData.id,
        organizationId: primaryBrand.id,
        coBrandId: coBrand.id,
        key: 'radius',
        userId,
        value: data.radius,
      })
      .catch((err) => { console.error(err); });
    setRadius(parseInt(data.radius));
    navigate('/dashboard/');    
  }

  return (
    <ErrorBoundary>
      <Navigation />
      <Container>
        <Row align="center" style={{
          minHeight: 'calc(100vh - 105px)',
          paddingBottom: '52.5px',
        }}>
          <Col sm={8}>
            <form onSubmit={ handleSubmit(onSubmit) }>
              <input { ...register('radius') } name="radius" type="radio" id="radius-1" value="1" hidden />
              <input { ...register('radius') } name="radius" type="radio" id="radius-10" value="10" hidden />
              <input { ...register('radius') } name="radius"  type="radio" id="radius-100" value="100" hidden />
              <h1 className="f-serif f-normal">
                Choose a radius of interest from the center of <Link className="f-italic" to="/zip/">{currZip}</Link> for <Link className="nowrap f-italic" to="/organization/">{currName}</Link>
              </h1>
              <label className="f-serif f-large mb-2 py-4 px-2 block outline" htmlFor="radius-1">
                <strong className="f-sans">1-mile radius</strong> Targeted insights for urban clinics
              </label>
              <label className="f-serif f-large mt-4 mb-2 py-4 px-2 block outline" htmlFor="radius-10">
                <strong className="f-sans">10-mile radius</strong> Broader insights for organizations serving larger, rural or suburban populations
              </label>
              <label className="f-serif f-large mt-4 mb-4 py-4 px-2 block outline" htmlFor="radius-100">
                <strong className="f-sans">100-mile radius</strong> General insights for large organizations without much geographic specificity
              </label>
              <button className="mt-4" type="submit">View Data</button>
              <br />
              { errors.radius && <span>{errors.radius.message.toString()}</span> }
            </form>
          </Col>
        </Row>
      </Container>
    </ErrorBoundary>
  );
};

export default IntroRadius;
